import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '../../../themes/defaultTheme';

const ButtonWithFontAwesome: React.FC<any> = (props) => {
  const { endIcon, startIcon, text, className, ...rest } = props;
  const classes = useStyles();

  const setIcon = (icon) => <FontAwesomeIcon icon={icon} />;

  return (
    <Button
      startIcon={startIcon && setIcon(startIcon)}
      endIcon={endIcon && setIcon(endIcon)}
      className={`${className} ${classes.text}`}
      {...rest}
    >
      {text}
    </Button>
  );
};

const useStyles = makeStyles(() => ({
  text: {
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
}));

export default ButtonWithFontAwesome;
